import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  MultiStockReceiptsResult,
  PurchaseReceiptsReport,
  SalesOrderStockAllocation,
  StockItemAmendment,
  StockItemHeaderReceipt,
  StockReceiptsResult,
} from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class StockItemHeaderReceiptService extends TmsWebBaseEditCreateService<
  StockItemHeaderReceipt,
  StockItemHeaderReceipt
> {
  public refreshDetails = new Subject<StockItemHeaderReceipt>();
  public autoPickResult$ = new Subject<SalesOrderStockAllocation[]>();

  constructor() {
    super('StockItemHeaderReceipt', $localize`Stock Item Header Receipt`);
  }

  override save(model: StockItemHeaderReceipt): Observable<string> {
    return this.httpService.post<StockReceiptsResult>(`${this.apiUrl}/SaveWithAutoPick`, model).pipe(
      map((result: StockReceiptsResult) => {
        if (result?.autoPickedAllocation) {
          this.autoPickResult$.next([result.autoPickedAllocation]);
        }
        return result?.stockItemHeaderId;
      }),
    );
  }

  amendStockAlreadyReceived(stockItemAmendment: StockItemAmendment): Observable<StockItemHeaderReceipt> {
    return this.httpService.post<StockItemHeaderReceipt>(
      `${this.apiUrl}/AmendStockAlreadyReceived`,
      stockItemAmendment,
    );
  }

  multiReceiveStock(ids: string[], quantities: number[], overrideShortAllocation = false): Observable<string[]> {
    return this.httpService
      .post<MultiStockReceiptsResult>(`${this.apiUrl}/MultiReceiveStockWithAutoPick`, {
        ids,
        quantities,
        overrideShortAllocation,
      })
      .pipe(
        map((result: MultiStockReceiptsResult) => {
          if (result?.autoPickedAllocations?.length) {
            this.autoPickResult$.next(result.autoPickedAllocations);
          }
          return result?.stockItemHeaderIds ?? [];
        }),
      );
  }

  stockReceivedPurchaseOrder(id: string): Observable<StockItemHeaderReceipt> {
    return this.httpService.get<StockItemHeaderReceipt>(
      `${this.apiUrl}/StockReceiptsPurchaseOrder?purchaseOrderLineId=${id}`,
    );
  }

  purchaseReceiptReport(deliveryNote: string): Observable<PurchaseReceiptsReport> {
    return this.httpService.get<PurchaseReceiptsReport>(
      `${this.apiUrl}/PurchaseReceiptReport?deliveryNote=${deliveryNote}`,
    );
  }

  relocateCallOff(purchaseOrderLineId: string, comments: string, ids: string[], quantity: number[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/RelocateCallOff`, {
      purchaseOrderLineId,
      comments,
      ids,
      quantity,
    });
  }

  getNextBatchNumber(): Observable<number> {
    return this.httpService.get<number>(`${this.apiUrl}/GetNextBatchNumber`);
  }
}
